import { render, staticRenderFns } from "./ActiveService.vue?vue&type=template&id=2d29a9ba"
import script from "./ActiveService.vue?vue&type=script&lang=js"
export * from "./ActiveService.vue?vue&type=script&lang=js"
import style0 from "./ActiveService.vue?vue&type=style&index=0&id=2d29a9ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports